import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/diklatService";

import DataTableBloc from "../Blocs/IndexBloc";
import apiResponse from "../../../../../services/apiResponse";

import moment from "moment";

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();

  peg_uuid = !accessRole("approve")
    ? JSON.parse(localStorage.getItem("userdata")) != null
      ? JSON.parse(localStorage.getItem("userdata")).employee_uuid
      : ""
    : JSON.parse(localStorage.getItem("employeeSelected")) != null
    ? JSON.parse(localStorage.getItem("employeeSelected")).employee_uuid
    : "";

  source;
  historyTable = "historyCP3KTable";
  defaultOrder = "decree_cp3k_id";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      approveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  dateParse = (input) => {
    let res = "-";
    if (input != "" && input != null) {
      res = moment(input).format("DD/MM/YYYY");
    }
    return res;
  };

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      employee_uuid: this.peg_uuid,
      training_type: this.props.type,
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.inactiveData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {
      this.loadData();
    }
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel?.unsubscribe();
  }

  columns = [
    {
      key: "decree_cp3k_decree_number",
      text: "Nomor SK",
      sortable: true,
    },
    {
      key: "decree_cp3k_decree_date",
      text: "Tanggal SK",
      sortable: true,
      cell: (record) => {
        return this.dateParse(record.decree_cp3k_decree_date);
      },
    },
    {
      key: "decree_cp3k_decree_tmt",
      text: "TMT SK",
      sortable: true,
      cell: (record) => {
        return this.dateParse(record.decree_cp3k_decree_tmt);
      },
    },
    {
      key: "decree_cp3k_status_name",
      text: "Status",
      className: "decree_cp3k_status_name",
      sortable: true,
      width: "100",
      cell: (record) => {
        var status = record.decree_cp3k_status;
        var status_name = record.decree_cp3k_status_name;
        return (
          <span>
            {parseInt(status) == 1 ? (
              <label className="badge rounded-pill bg-soft-success font-size-12">
                {status_name}
              </label>
            ) : (
              <label className="badge rounded-pill bg-soft-warning font-size-12">
                {status_name}
              </label>
            )}
          </span>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.decree_cp3k_id;
        const status = record.decree_cp3k_status;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.decree_cp3k_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detil
              </Tooltip>
            </span>
            {accessRole("update") && (status == 1 || status == 2) ? (
              <span>
                <button
                  className="btn btn-warning btn-sm"
                  id={"update-" + thisId}
                  onClick={() => {
                    this.setState({
                      updateUuid: record.decree_cp3k_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-pen"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["update" + thisId]}
                  target={"update-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["update" + thisId]: !this.state["update" + thisId],
                    });
                  }}
                >
                  Perbaharui
                </Tooltip>
              </span>
            ) : null}
            {accessRole("delete") && status == 1 ? (
              <span>
                <button
                  className="btn btn-danger btn-sm"
                  id={"delete-" + thisId}
                  onClick={() => {
                    this.setState({
                      inactiveUuid: record.decree_cp3k_uuid,
                      confirm: true,
                    });
                  }}
                  style={{
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-trash-alt"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["delete" + thisId]}
                  target={"delete-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["delete" + thisId]: !this.state["delete" + thisId],
                    });
                  }}
                >
                  Nonaktifkan
                </Tooltip>
              </span>
            ) : null}
            {accessRole("approve") && status == 0 ? (
              <span>
                <button
                  className="btn btn-success btn-sm"
                  id={"approve-" + thisId}
                  onClick={() => {
                    this.setState({
                      approveUuid: record.decree_cp3k_uuid,
                    });
                  }}
                  style={{
                    marginRight: "2px",
                    padding: "2px 5px",
                  }}
                >
                  <i className="uil-check"></i>
                </button>
                <Tooltip
                  style={{
                    marginBottom: 2,
                  }}
                  placement="top"
                  isOpen={this.state["approve" + thisId]}
                  target={"approve-" + thisId}
                  toggle={() => {
                    this.setState({
                      ["approve" + thisId]: !this.state["approve" + thisId],
                    });
                  }}
                >
                  Approve
                </Tooltip>
              </span>
            ) : null}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menghapus data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil dihapus"
          failedTitle="Gagal!"
          failedInfo="Data gagal dihapus"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={`/kepegawaian/home.html?skcp3k&detail&uuid=${this.state.detailUuid}`}
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={`/kepegawaian/home.html?skcp3k&update&uuid=${this.state.updateUuid}`}
          />
        ) : null}
        {this.state.approveUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/home.html?skcp3k&approve&uuid=" +
              this.state.approveUuid
            }
          />
        ) : null}
      </>
    );
  }
}

export default TableActiveComponent;
